<template>
<span>

    <v-toolbar flat color="white">
        <v-toolbar-title>
            <img v-if="downloadcategory.down_c_icone" :src="`${base_url}upload/download_category/i/${downloadcategory.down_c_icone}`" width="40">
            <img v-if="!downloadcategory.down_c_icone" :src="`${base_url}upload/imagem.png`" width="40">
        </v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <h1  class="lime--text lighten-1">{{ downloadcategory.down_c_nome }}</h1>
        <v-spacer></v-spacer>
        <template>
            <v-btn color="blue-grey" dark class="mb-2" :to="{name: 'download-categories'}">
                <v-icon dark>keyboard_arrow_left</v-icon> Voltar
            </v-btn>
        </template>
    </v-toolbar>

    <table id="table-detalhe" class="table table-bordered table-condensed">
        <tbody>
            <tr>
                <th width="10%">Nome:</th>
                <td width="90%">{{ downloadcategory.down_c_nome }}</td>
            </tr>
            <tr>
                <th width="10%">Descrição:</th>
                <td width="90%">{{ downloadcategory.down_c_descricao }}</td>
            </tr>
            <tr>
                <th width="10%">Status:</th>
                <td width="90%">{{ (downloadcategory.down_c_status == '1') ? 'Ativo' : 'Inativo' }}</td>
            </tr>
            <tr>
                <th width="10%">Icone:</th>
                <td v-if="downloadcategory.down_c_icone" width="10%">
                    <img :src="`${base_url}upload/download_category/i/${downloadcategory.down_c_icone}`" width="60">
                </td>
                <td v-if="!downloadcategory.down_c_icone" width="10%">
                    <img :src="`${base_url}upload/imagem.png`">
                </td>
            </tr>
            <tr>
                <th width="10%">Imagem:</th>
                <td v-if="downloadcategory.down_c_imagem" width="10%">
                    <img :src="`${base_url}upload/download_category/b/${downloadcategory.down_c_imagem}`" width="400">
                </td>
                <td v-if="!downloadcategory.down_c_imagem" width="10%">
                    <img :src="`${base_url}upload/imagem.png`">
                </td>
            </tr>
        </tbody>
    </table>

</span>
</template>

<script>
import {
    URL_BASE
} from '../../../config/configs'

export default {
    name: "DetailDownloadComponent",
    created() {
        this.loadDownloadCategory()
    },
    props: {
        down_c_id: {
            require: true
        },
    },
    data() {
        return {
            search: '',
            downloadcategory: {},
            base_url: URL_BASE
        }
    },
    methods: {
        loadDownloadCategory() {
            this.$store.dispatch('loadDownloadCategory', this.down_c_id)
                .then(response => {
                    this.downloadcategory = response
                })
                .catch(error => {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: 'Erro',
                        text: 'Dados não localizado',
                        showConfirmButton: true,
                        timer: 6000
                    });
                })
        },
    }
};
</script>

<style scoped>
.avatar {
    height: 25px;
}

.logo {
    height: 50px;
}
</style>
